/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import metrics from '@adobe/exc-app/metrics';
import PropTypes from 'prop-types';
import React from 'react';

class Iframe extends React.Component {
  constructor(props) {
    super(props);
    this.id = 'exc-app-sandbox-' + Math.random();
    this.onPostMessage = this.onPostMessage.bind(this);
    this.onLoad = this.onLoad.bind(this);
    this.metrics = metrics.create('exc.core.modules.Iframe', props);
    this.metrics.event('Iframe.constructed');
    this.iframeTimer = this.metrics.start('Sandbox.iframe');
  }

  componentDidMount() {
    window.addEventListener('message', this.onPostMessage, false);
    this.props.onMount(this.box);
    this.iframeTimer.time('init'); // step 8
  }

  componentWillUnmount() {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
    window.removeEventListener('message', this.onPostMessage, false);
  }

  shouldComponentUpdate(nextProps) {
    return nextProps.src && this.props.src !== nextProps.src;
  }

  onLoad() {
    this.iframeTimer.time('onLoad');

    if (this.timeout) {
      clearTimeout(this.timeout);
    }

    this.timeout = setTimeout(() => {
      this.props.onError();
    }, this.props.timeout);
    this.props.onLoad(this.box);
  }

  onPostMessage(event) {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }

    if (event.origin) {
      this.props.onMessage(this.box, event);
    }
  }

  render() {
    return (
      <iframe
        allow="fullscreen"
        allowFullScreen
        className={this.props.className}
        id={this.id}
        name={this.props.name}
        onLoad={this.onLoad}
        ref={r => (this.box = r)}
        src={this.props.src}
        title={this.props.name}
      />
    );
  }
}

Iframe.defaultProps = {
  name: '',
  onError: function () {},
  onLoad: function() {},
  onMessage: function() {},
  onMount: function() {}
};

Iframe.propTypes = {
  onLoad: PropTypes.func,
  onMessage: PropTypes.func,
  src: PropTypes.string.isRequired
};

export default Iframe;
